import {Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { BaseComponent } from '@wms/components';
import { CommonModule } from '@angular/common';
import { PageService } from '@wms/services';
import { runtimeEventManager } from "@wm/core";
import {PageWsService} from "@wms/workspace";
import {getCanvasElement} from "@wms/core";

@Component({
  standalone: true,
  selector: 'wms-view-selector',
  templateUrl: './wms-view-selector.component.html',
  styleUrls: ['./wms-view-selector.component.less'],
  imports: [CommonModule]
})
export class WmsViewSelectorComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() pageInfo: any;
  @Input() override views: any;
  @Output() onViewSelect: EventEmitter<any> = new EventEmitter<any>();
  hideLeftBtn: boolean = true;
  hideRightBtn: boolean = true;
  maxMarginLeft: any;
  liWidth: any;
  pathWidth: any;
  selectedView: any = {};
  disableLeftBtn: boolean;
  pageType: any;
  disableRightBtn: boolean;
  activePageName: string;
  $xPath: any;
  protected isPrefabType: boolean;

  constructor(private pageService: PageService) {
    super();
    this.isPrefabType = this.projectService.isPrefabType();
   }

  ngOnChanges(changes: SimpleChanges): void {
    const currentValue: any = changes['views'] && changes['views']['currentValue'];
    const prevValue: any = changes['views'] && changes['views']['previousValue'];
    if (currentValue?.length !== prevValue?.length) {
      if (this.activePageName !== this.pageService.activePageName && !changes['views']['firstChange']) {
        this.activePageName = this.pageService.activePageName;
        this.emitOnViewSelect();
      }
      this.showOrHideNav();
    }
  }

  showOrHideNav(){
    const scrollEl = $(document).find('.scroll-container');
    setTimeout(() => {
      if (scrollEl[0].offsetWidth < scrollEl[0].scrollWidth) {
        this.hideLeftBtn = this.hideRightBtn = false;
      } else {
        this.hideLeftBtn = this.hideRightBtn = true;
      }
    }, 0);
  }

  ngOnInit(): void {
    this.activePageName = this.pageService.activePageName;
    this.emitOnViewSelect();
    this.eventManager.viewUpdateOnDeleteObservable().subscribe((data:any) => {
      if(data?.parentWidgetId === this?.selectedView?.value?.parentWidgetId){
        this.emitOnViewSelect();
        this.eventManager.emitLoadView({selectedView: this.selectedView.value});
      }
    })
    this.registerDestroyListener.add(runtimeEventManager.on('widget-name').subscribe((data: any) => {
      if (this.selectedView.value.widgetId === data.widgetId) {
        this.selectedView.value.name = data.name;
        this.selectedView.value.displayName = data.name;
      }
    }));
    this.registerDestroyListener.add(this.eventManager.pageRenderedObservable().subscribe(() => {
      this.showPageViewByDefault();
    }));
    this.registerDestroyListener.add(this.eventManager.updateViewSelectorObservable().subscribe(() => {
      this.showPageViewByDefault();
    }));
    this.registerDestroyListener.add(this.eventManager.updateOnTabSwitchForNav().subscribe(() => {
    this.showOrHideNav();
    }));

  }

  emitOnViewSelect() {
    this.$xPath = $(document).find('.scroll-container');
    this.pageType = this.pageInfo?.isPartial ? '$PARTIAL$' : '$PAGE$';
    this.selectedView.value = this.pageType;
    this.onViewSelect.emit({selectedView: this.selectedView.value});
  }

  moveLeft() {
    this.$xPath[0].scrollLeft -= 60;
  }

  moveRight() {
    this.$xPath[0].scrollLeft += 60;
  }

  setPageType() {
    this.pageType = this.pageInfo.isPartial ? '$PARTIAL$' : '$PAGE$';
    this.selectedView.value = this.pageType;
  }

  showPageViewByDefault() {
    $(getCanvasElement()).find('[wmdialog], [wmalertdialog], [wmconfirmdialog], [wmiframedialog], [wmpagedialog], [wmlogindialog], [wmbottomsheet]').hide();
    this.emitOnViewSelect();
  }

}
